import gql from "graphql-tag";

export const KLEER_COMPANY_INFO_QUERY = gql`
    query kleerCompanyInfo($companyId: String) {
        kleerCompanyInfo(companyId: $companyId) {
            name
            orgno
            accountingCurrency
            bankgiro
            supplierInvoiceEmail
        }
    }
`;

export const KLEER_ACCOUNT_METADATA_QUERY = gql`
    query kleerAccountMetadata($startDate: GraphQLDateString!, $endDate: GraphQLDateString!, $companyId: String) {
        kleerAccountMetadata(startDate: $startDate, endDate: $endDate, companyId: $companyId) {
            accountNr
            description
            inBalance
            outBalance
            debitCount
            creditCount
            disabled
        }
    }
`;

export const KLEER_ACCOUNTING_YEARS_QUERY = gql`
    query kleerAccountingYears($companyId: String) {
        kleerAccountingYears(companyId: $companyId) {
            id
            startDate
            endDate
        }
    }
`;

export const KLEER_VOUCHERS_QUERY = gql`
    query kleerVouchers($startDate: GraphQLDateString, $endDate: GraphQLDateString, $companyId: String) {
        kleerVouchers(startDate: $startDate, endDate: $endDate, companyId: $companyId) {
            serie
            number
            description
            date
            turnover
            transactions {
                accountNr
                amount
                vatCode
            }
        }
    }
`;

export const KLEER_REVENUE_LEDGERS_QUERY = gql`
    query kleerRevenueLedgers($offset: Int, $limit: Int, $companyId: String) {
        kleerRevenueLedgers(offset: $offset, limit: $limit, companyId: $companyId) {
            id
            name
            accountNr
        }
    }
`;

export const KLEER_REVENUES_QUERY = gql`
    query kleerRevenues(
        $ledgerId: Int!
        $offset: Int
        $limit: Int
        $filter: String
        $lowerDate: GraphQLDateString
        $upperDate: GraphQLDateString
        $companyId: String
    ) {
        kleerRevenues(
            ledgerId: $ledgerId
            offset: $offset
            limit: $limit
            filter: $filter
            lowerDate: $lowerDate
            upperDate: $upperDate
            companyId: $companyId
        ) {
            id
            ledger {
                id
            }
            externalId
            countryCode
            transactionDate
            rows {
                product {
                    id
                }
                originalAmount {
                    amount
                    vat
                    currency
                }
                accountingAmount {
                    amount
                    vat
                }
                period {
                    start
                    end
                }
            }
        }
    }
`;

export const KLEER_RESULT_REPORT_QUERY = gql`
    query kleerResultReport(
        $startDate: GraphQLDateString
        $endDate: GraphQLDateString
        $filterByDimensionEntryId: Int
        $groupByDimensionId: Int
        $companyId: String
    ) {
        kleerResultReport(
            startDate: $startDate
            endDate: $endDate
            filterByDimensionEntryId: $filterByDimensionEntryId
            groupByDimensionId: $groupByDimensionId
            companyId: $companyId
        )
    }
`;
